import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { AppConfig } from '../../../app.settings';
import { Role } from '../../models/entities/role.type';

@Injectable()
export class UtilsService {
  private endpoint: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig
  ) {
    this.endpoint = `${this.config.getConfig('api')}Utils`;
  }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.endpoint}/GetRoles`);
  }

  getLanguages(): Observable<any[]> {
    return this.http.get<any[]>('./assets/lang.json', {
      headers: new HttpHeaders({ 'No-Auth': 'True' }),
    });
  }

  getAgentUpdateFileName(): Observable<string> {
    return this.http.get<string>(`${this.endpoint}/GetUpdateFileName`);
  }

  getApkUpdateFileName(): Observable<string> {
    return this.http.get<string>(`${this.endpoint}/GetUpdateApkFileName`);
  }

  setAgentUpdateFileName(fileName: string): Observable<void> {
    const params = new HttpParams()
      .set('fileName', fileName);

    return this.http.get<void>(`${this.endpoint}/SetUpdateFileName`, { params });
  }

  getSpacedeskApkFile(): Observable<string> {
    return this.http.get<string>(`${this.endpoint}/GetSpacedeskAPKVersion`);
  }

  setSpacedeskApkFile(fileName: string): Observable<void> {
    let params = new HttpParams();

    if (fileName) {
      params = params.set('spacedeskAPKVersion', fileName);
    }
    return this.http.get<void>(`${this.endpoint}/SetSpacedeskAPKVersion`, { params });
  }
}
